var stats = {
  initialize: function (container, cta) {
    $(container)
      .find(".range-start")
      .datetimepicker({
        defaultDate: new Date().setHours(0, 0, 0, 0),
      });

    $(container)
      .find(".range-end")
      .datetimepicker({
        defaultDate: new Date().setHours(23, 59, 59, 999),
      });

    $(container)
      .find(".timeframe")
      .on("change", function () {
        if ($(this).val() == "daterange") {
          $(container).find(".range-selector").show();
        } else {
          $(container).find(".range-selector").hide();
          ctas.stats.run(container, cta);
        }
      });

    $(container)
      .find(".range-selector .date")
      .each(function () {
        $(this).on("dp.change", function (ev) {
          ctas.stats.run(container, cta);
        });
      });

    $(container)
      .find('select[data-type="conversion-type"][data-id="' + cta.id + '"]')
      .on("change", function () {
        var label = $(this).find("option:selected").text() + "s";
        $(container).find(".chart-type-label").html(label);
        ctas.stats.run(container, cta);
      });

    ctas.stats.run(container, cta);
  },

  run: function (container, cta) {
    if ($(container).find(".timeframe").val() !== "daterange") {
      var timeframe =
        reports.rangeMap[
          $(container).find(".timeframe").find("option:selected").text()
        ];
      var range_start = $(container).find(".timeframe").val();
      var range_end = new Date();
    } else if (
      $(container).find(".range-start input").val() !== "" &&
      $(container).find(".range-end input").val() !== ""
    ) {
      var range_start = new Date(
        Date.parse($(container).find(".range-start input").val())
      );
      var range_end = new Date($(container).find(".range-end input").val());
      var timeframe = reports.groupByType(range_start, range_end);
    }

    var event_type = $(container)
      .find('select[data-type="conversion-type"][data-id="' + cta.id + '"]')
      .val();
    var query = {
      event_type: event_type,
      contactable_type: "Cta",
      contactable_id: cta.id,
    };

    reports.getChart(
      window.location.origin + "/websites/" + cta.website_id + "/reports/",
      "cta-" + cta.id + "-reports-chart",
      "ColumnChart",
      {
        website_id: cta.website_id,
        table: "Event",
        range_start: range_start,
        range_end: range_end,
        result_type: "group_by_date",
        group_by: timeframe,
        query: query,
      }
    );

    reports.getReport(
      window.location.origin + "/websites/" + cta.website_id + "/reports/",
      "cta-" + cta.id + "-reports-count",
      "cta-" + cta.id + "-reports-chart",
      {
        website_id: cta.website_id,
        table: "Event",
        range_start: range_start,
        range_end: range_end,
        result_type: "unique_count",
        value: "visitor_token",
        query: query,
      }
    );
  },
};

export default stats;
